import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { FaFeatherAlt } from 'react-icons/fa';


function Caraousal_Testimonial(){  
        
     
    return(
        <OwlCarousel className='testimonial_owl' loop margin={30} items={1} dots={false} autoplay={true} slideBy={1}  nav={false} smartSpeed={650}>

             <div className='item'> 
                <h3>Nice idea to save or write travel diaries or stories. made all easy to 
                    plan and review before leaving . Great !!</h3>
                    <p className="mt-3"><strong><FaFeatherAlt /> Methili</strong> <small>North Goa, India</small></p>                  
            </div>

            <div className='item'> 
                <h3>Great idea to save or write travel diaries or stories. made all easy to 
                    plan and review before leaving . Great !!</h3>
                    <p className="mt-3"><strong><FaFeatherAlt /> Mukul</strong> <small>Delhi, India</small></p>                  
            </div>

            <div className='item'>  
                <h3>Awesome idea to save or write travel diaries or stories. made all easy to 
                    plan and review before leaving . Great !!</h3>
                <p className="mt-3"><strong><FaFeatherAlt /> Nilika</strong> <small>Manali, India</small></p>                  
            </div>


            </OwlCarousel>
    )
}

export default Caraousal_Testimonial;